export const API_BASE = process.env.REACT_APP_API;

export const GATE_USERNAME = process.env.REACT_APP_GATE_USERNAME;
export const GATE_PASSWORD = process.env.REACT_APP_GATE_PASSWORD;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const GATE_TOKEN_HEADER = "x-api-token";
export const API_AUTHEN = `${API_BASE}/API/Authen`;

export const API_GETPACKAGE = `/Package/GetPackages`;
export const API_REGISTER = `/Tenant/Registrations`;
export const API_USERNANE_DUP = `/Tenant/UsernameDuplicate`;
export const API_USER_AUTHENTICATION = "/Auth/Authentication";

export const API_ADDBUSINESSTYPE = `/Customer/AddBusinessType`;
export const API_GETBUSINESSTYPE = `/Customer/GetBusinessType`;
export const API_EDITBUSINESSTYPE = `/Customer/EditBusinessType`;
export const API_DELBUSINESSTYPE = `/Customer/DelBusinessType`;

export const API_ADDCUSTOMER = `/Customer/AddCustomer`;
export const API_GETCUSTOMERS = `/Customer/GetCustomers`;
export const API_EDITCUSTOMER = `/Customer/EditCustomer`;

export const API_GETZIPCODE = `/Data/GetDataViaZipcode`;

export const API_ADDPRODUCT = `/Product/AddProduct`;
export const API_GETPRODUCTS = `/Product/GetProducts`;
export const API_EDITPRODUCT = `/Product/EditProduct`;
export const API_DELPRODUCT = `/Product/DelProduct`;

export const API_GETUNITS = `/Service/GetUnits`;

export const API_GETSERVICES = `/Service/GetServices`;
export const API_ADDSERVICE = `/Service/AddService`;
export const API_EDITSERVICE = `/Service/EditService`;
export const API_DELSERVICE = `/Service/DelService`;
export const API_GETSERVICEPRODUCTS = `/Service/GetServiceProducts`;

export const API_GETSERVICEPACKAGES = `/Service/GetServicePackages`;
export const API_GETSERVICEWITHPRODUCTS = `/Service/GetServiceWithProducts`;

export const API_GETCUSTOMERWITHPACKAGE = `/Customer/GetCustomerWihPackage`;
export const API_BUYSERVICEPACKAGE = `/Service/BuyServicePackage`;

export const API_GETORG = `/Org/GetOrg`;
export const API_EDITORG = `/Org/EditOrg`;

export const API_ADDBRANCH = `/Branch/AddBranch`;
export const API_GETBRANCHS = `/Branch/GetBranchs`;
export const API_GETBRANCHBYID = `/Branch/getBranchById`;
export const API_EDITBRANCH = `/Branch/EditBranch`;

export const API_GETPOSITIONS = "/Position/GetPositions";

export const API_ADDEMPLOYEE = `/Employee/AddEmployee`;
export const API_GETEMPLOYEES = `/Employee/GetEmployees`;
export const API_GETEMPLOYEEBYID = `/Employee/GetEmployeeById`;
export const API_EDITEMPLOYEE = `/Employee/EditEmployee`;
export const API_DELEMPLOYEE = `/Employee/DelEmployee`;

export const API_CREATEBILL = `/Bill/CreateBill`;

export const API_GETBILL = `/Bill/GetBill`;
export const API_GETBILLDETAIL = `/Bill/GetBillDetail`;
export const API_UPDATEBILL = `/Bill/UpdateBill`;

export const API_UPDATESETTING = `/Setting/EditSetting`;
export const API_GETSETTING = `/Setting/GetSetting`;
